import ef from 'ef/ef';
var utils = require('lib/utils');

var ForgeService = {
  initialize: function () {},
  getForgeModeStatus: function () {
    if (ef.forge_mode) {
      if (ef.forge_mode.hasOwnProperty('active')) {
        if (ef.forge_mode.active) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  getForgeModeIcon: function (set, key) {
    if (ef.forge_mode) {
      try {
        return ef.forge_mode.icons[set][key];
      } catch (err) {
        this.sendToConsole('getForgeModeIcon: ' + err.message);
      }
    }
    return '<span>*</span>';
  },
  toggleForgeMode: function () {
    if (ef.forge_mode) {
      ef.forge_mode.active = !this.getForgeModeStatus();
      this.updateForgeModeElements();
    }
  },
  startDragFromForge: function (pattern) {
    let contentRegionSelector = '';
    const patharr = pattern.path.split(',');
    if (patharr.length >= 1) {
      switch (pattern.path.split(',')[0]) {
        case 'uipatterns':
        case '.before-content':
          // TODO Send pattern content region for other regions
          contentRegionSelector = '.before-content';
          break;
        case 'contentpatterns':
        case '#page-container':
          contentRegionSelector = '#page-container';
          break;
        default:
          break;
      }
    }
    $(`${contentRegionSelector} .blockDropTarget`).css('visibility', 'visible');
  },
  endDragFromForge: function () {
    $('.blockDropTarget').css('visibility', 'hidden');
  },
  sendToConsole: function (msg) {
    if (window.parent) {
      window.parent.postMessage(
        { event_type: 'forge_mode', detail: { action: 'console', msg } },
        window.location.origin
      );
    }
  },
  deepLookup: function (obj, path) {
    parts = path.split('.');
    if (parts.length == 1) {
      return obj[parts[0]];
    }
    return deepLookup(obj[parts[0]], parts.slice(1).join('.'));
  },
  getSubPaths: function (type, path) {
    var retval;
    if (type === 'layout') {
      // do nothing
    } else if (ef.forge_mode.hasOwnProperty('subPaths')) {
      if (type === 'component') {
        try {
          retval = this.deepLookup(ef.forge_mode.subPaths.components, path.split('/').join('.')).subpaths;
        } catch (err) {
          this.sendToConsole(`getSubPaths component (${path}) error: ${err.message}`);
        }
      } else {
        try {
          if (_.isArray(ef.forge_mode.subPaths.blocks[type].subpaths)) {
            retval = ef.forge_mode.subPaths.blocks[type].subpaths.slice(0);
          }
        } catch (err) {
          this.sendToConsole(`getSubPaths block (${type}) error: ${err.message}`);
        }
      }
    }
    if (_.isArray(retval)) {
      if (retval.length >= 1) {
        return retval;
      }
    }
    return [];
  },
  updateForgeModeElements: function () {
    if (ef.forge_mode) {
      if (ef.forge_mode.hasOwnProperty('active')) {
        if (ef.forge_mode.active) {
          requestAnimationFrame(() => {
            $('.forgeModeElement').show();
            // $('#page-container span[data-forgeaction="editlocale"]').parent();
            // $('.feedback span[data-forgeaction="editlocale"]').parent();
          });
        } else {
          requestAnimationFrame(() => {
            $('#page-container .forgeModeElement').hide();
            $('#page-header.before-content .forgeModeElement').hide();
            // $('#page-container span[data-forgeaction="editlocale"]').parent();
            $('#page-container *[data-cid^="c"]').css('background-color', 'unset');
            $('.feedback .forgeModeElement').hide();
            // $('.feedback span[data-forgeaction="editlocale"]').parent();
            $('.feedback *[data-cid^="c"]').css('background-color', 'unset');
            $('#contextMenus').hide();
          });
        }
      }
    }
  },
  initContextMenus: function () {
    if (!$('#contextMenus').length) {
      var $menuElement = $(`<div id='contextMenus'></div>`);
      $menuElement.appendTo('#main-container');
      $('#main-container').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(function () {
          $('.contextMenu').hide();
          $('#contextMenus').hide();
        }, 75);
      });
    }
  },
  traverseBlocks: function (obj, path, contentRegion) {
    for (var i in obj) {
      if (obj[i] !== null && typeof obj[i] === 'object') {
        if (path[path.length - 1] === 'blocks') {
          obj[i].forge_path = path.join() + ',' + i;
          obj[i].content_region = contentRegion;
        }
        let newpath = [];
        if (!utils.isEmpty(path)) {
          newpath = path.join().split(',');
        }
        newpath.push(i);
        this.traverseBlocks(obj[i], newpath, contentRegion);
      }
    }
  },
  applyForgeControls: function (sel = '#page-container', contentRegionSelector = '#page-container') {
    const getForgeControlParams = (action, context, paramObj) => {
      var params = { action: action };
      params.data = {};
      Object.keys(paramObj).forEach(function (key) {
        params.data[key] = $(context).data(paramObj[key]);
      });
      return params;
    };
    if (ef.forge_mode) {
      var icn = this.getForgeModeIcon('far', 'edit');
      // Reset the list of locales
      if (sel === '#page-container') {
        Object.keys(ef.forge_mode.currentPageLocales).forEach(function (key) {
          delete ef.forge_mode.currentPageLocales[key];
        });
      }
      //
      // Before Content Region
      const $beforeContentPlaceholder = $(
        `<div class="forgeModeElement blockDropTarget forgeDataRegion btn" data-objpath="" data-content-region=".before-content" data-sdkcid="placeholder">+</div>`
      );
      $beforeContentPlaceholder.css('visibility', 'hidden');
      requestAnimationFrame(() => {
        $('#page-header.before-content > div.block-list').append($beforeContentPlaceholder);
      });
      //
      // Page Root Region
      const pageMarker = $('#page-container > div.block-list');
      pageMarker.each(function () {
        let $controlElement = $(
          `<div class="forgeModeElement blockDropTarget forgeDataRegion btn" data-objpath="" data-content-region="#page-container" data-sdkcid="placeholder">+</div>`
        );
        $controlElement.css('visibility', 'hidden');
        requestAnimationFrame(() => {
          $controlElement.appendTo($(this));
        });
      });
      //
      // Block Data Regions
      const dataRegionMarkers = $(sel + ' div[data-region]');
      dataRegionMarkers.each(function () {
        let $parentMarker = $(this).closest('div[data-objpath]');
        if ($(this).closest('div[data-iscomponent="true"]').length) {
          // skip regions that are inside of components (for now)
        } else {
          let objpath = $parentMarker.data('objpath');
          let regionName = $(this).data('region');
          let regionType = regionName.split('-')[1].slice(0, 6);
          if (regionType === 'region') {
            // handle layout regions
            objpath += `,regions,${regionName.slice(-1)[0]}`;
          }
          let $controlElement = $(
            `<div class="forgeModeElement blockDropTarget forgeDataRegion btn" data-content-region="${contentRegionSelector}" data-objpath="${objpath}" data-sdkcid="placeholder">+</div>`
          );
          $controlElement.css('visibility', 'hidden');
          requestAnimationFrame(() => {
            $controlElement.appendTo($(this));
          });
        }
      });
      //
      // Invisible Blocks (e.g., 'Modal')
      var blockMarkers = $(sel + ' span[data-forgeaction="editblock"]');
      blockMarkers.each(function () {
        var params = getForgeControlParams('editblock', this, { label: 'label', cid: 'sdkcid', objpath: 'objpath' });
        var $controlElement = $(
          `<div class="forgeModeElement forgeLink forgeInvisibleLocaleEdit btn" data-sdkcid="${params.data.cid}" data-forgelink="${params.data.cid}" data-content-region="${contentRegionSelector}" data-objpath="${params.data.forgepath}" draggable="true">${params.data.label}</div>`
        );
        $controlElement.on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (window.parent) {
            window.parent.postMessage({ event_type: 'forge_mode', detail: params }, window.location.origin);
          }
        });
        var $iconElement = $(icn);
        requestAnimationFrame(() => {
          $iconElement.appendTo($controlElement);
          $controlElement.appendTo($(this));
        });
      });
      //
      // Plaintext Locale Fields
      icn = this.getForgeModeIcon('far', 'comment');
      var plainLocaleMarkers = $(sel + ' span[data-forgeaction="editlocaleplain"]');
      plainLocaleMarkers.each(function () {
        var params = getForgeControlParams('editlocaleplain', this, {
          translated: 'translated',
          key: 'key',
          objpath: 'objpath',
          label: 'label',
          cid: 'sdkcid',
        });
        params.rtf = false;
        params.contentRegion = contentRegionSelector;
        var $controlElement = $(
          `<div class="forgeModeElement forgeEditLocalePlain btn" data-sdkcid="${params.data.cid}" data-content-region="${contentRegionSelector}">${params.data.label}</div>`
        );
        if (params.translated === 'no') {
          $controlElement.css('color', 'red');
        }
        $controlElement.on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (window.parent) {
            window.parent.postMessage({ event_type: 'forge_mode', detail: params }, window.location.origin);
          }
        });
        var $iconElement = $(icn);
        requestAnimationFrame(() => {
          $iconElement.appendTo($controlElement);
          $controlElement.appendTo($(this));
        });
        ef.forge_mode.currentPageLocales[params.data.key] = {
          rtf: false,
        };
      });
      //
      // Rich Text Locale Fields
      icn = this.getForgeModeIcon('far', 'commentLines');
      var rtfLocaleMarkers = $(sel + ' span[data-forgeaction="editlocale"]');
      var rtfLocaleMarkerKeys = [];
      rtfLocaleMarkers.each(function () {
        var params = getForgeControlParams('editlocale', this, { translated: 'translated', key: 'key' });
        params.contentRegion = contentRegionSelector;
        params.rtf = true;
        var fc = $(`span[data-forgeaction="editlocale"] div[data-keylink="${params.data.key}"]`);
        if (fc.length === 0 || !rtfLocaleMarkerKeys.includes(params.data.key)) {
          rtfLocaleMarkerKeys.push(params.data.key);
          var $controlElement = $(
            `<div class="forgeModeElement forgeEditLocale btn" data-keylink="${params.data.key}"></div>`
          );
          $controlElement.css('visibility', 'hidden');
          if (params.translated === 'no') {
            $controlElement.css('color', 'red');
          }
          $controlElement.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.parent) {
              window.parent.postMessage({ event_type: 'forge_mode', detail: params }, window.location.origin);
            }
            $(sel + ' span[data-forgeaction="editlocale"]').parent();
          });
          var $iconElement = $(icn);
          requestAnimationFrame(() => {
            $iconElement.appendTo($controlElement);
            $controlElement.appendTo($(this));
          });
          // Highlight on hover
          $(this).hover(
            function () {
              requestAnimationFrame(() => {
                var keyref = $(this).data('key');
                if (ef.forge_mode.active) {
                  $(sel + ' span[data-forgeaction="editlocale"] p:last-of-type').css('display', 'inline-block');
                  $('div[data-keylink="' + keyref + '"]').css('visibility', 'visible');
                } else {
                  $(sel + ' span[data-forgeaction="editlocale"] p:last-of-type').css('display', 'unset');
                  $('div[data-keylink="' + keyref + '"]').css('visibility', 'hidden');
                }
              });
            },
            function () {
              requestAnimationFrame(() => {
                var keyref = $(this).data('key');
                $('span[data-key="' + keyref + '"]').css('background-color', 'unset');
                $('div[data-keylink="' + keyref + '"]').css('visibility', 'hidden');
              });
            }
          );
        }
        //
        ef.forge_mode.currentPageLocales[params.data.key] = {
          rtf: true,
        };
      });
      //
      requestAnimationFrame(() => {
        // Apply Block Drop Targets (for drag/drop block placement/ordering)
        $('.blockDropTarget').on('drop', function (ev, ui) {
          const el = $(ev.originalEvent.toElement);
          const contentRegion = el.data('content-region');
          ev.preventDefault();
          if (window.parent) {
            var dragData = ev.originalEvent.dataTransfer.getData('text');
            const dataTransfer = dragData.split('|');
            const sourceRegion = dataTransfer[0];
            const sourcePath = dataTransfer[1];
            switch (dragData.split('|')[0]) {
              case 'droplocaltemplate':
                window.parent.postMessage(
                  {
                    event_type: 'forge_mode',
                    detail: {
                      action: 'droplocaltemplate',
                      data: {
                        contentRegion: el.data('content-region'),
                        targetpath: el.data('objpath'),
                        dragData: dragData,
                        cid: el.data('sdkcid'),
                      },
                    },
                  },
                  window.location.origin
                );
                break;
              case 'droptemplate':
                window.parent.postMessage(
                  {
                    event_type: 'forge_mode',
                    detail: {
                      action: 'droptemplate',
                      data: {
                        contentRegion: el.data('content-region'),
                        targetpath: el.data('objpath'),
                        dragData: dragData,
                        cid: el.data('sdkcid'),
                      },
                    },
                  },
                  window.location.origin
                );
                break;
              default:
                // assume this is just a block being dragged around
                window.parent.postMessage(
                  {
                    event_type: 'forge_mode',
                    detail: {
                      action: 'dropblock',
                      data: {
                        contentRegion: sourceRegion,
                        targetpath: el.data('objpath'),
                        blockpath: sourcePath,
                        cid: el.data('sdkcid'),
                      },
                    },
                  },
                  window.location.origin
                );
                break;
            }
          }
        });
        $('.blockDropTarget').on('dragover', function (ev) {
          ev.preventDefault();
          // TTD - implement this
        });
        $('.blockDropTarget').on('dragout', function (ev) {
          ev.preventDefault();
          // TTD - implement this
        });
      });
      // Update List of Translated 'Page' Locales in Forge
      if (window.parent) {
        window.parent.postMessage(
          {
            event_type: 'forge_mode',
            detail: {
              action: 'updatelocales',
              data: {
                currentPageLocales: Object.assign({}, ef.forge_mode.currentPageLocales),
              },
            },
          },
          window.location.origin
        );
      }
      // Keyboard shortcuts
      if (!ef.forge_mode.keyboardShortcutsEnabled) {
        $(document).keydown(e => {
          if (e.keyCode >= 65 && e.keyCode <= 90) {
            var char = (e.metaKey ? '⌘-' : '') + String.fromCharCode(e.keyCode);
            switch (char) {
              case '⌘-E':
                this.toggleForgeMode();
                break;
              default:
                break;
            }
          }
        });
        ef.forge_mode.keyboardShortcutsEnabled = true;
      }
      // Hide/Show Control Elements
      this.updateForgeModeElements();
    }
  },

  applyForgeLink: function (target) {
    const createContextMenu = menuData => {
      var selector = 'forgeContextMenu_' + menuData.cid;
      if ($('#' + selector).length) {
        // skip; this menu already exists
      } else {
        var $controlElement = $(
          `<div id='${selector}' class='contextMenu'><div class='contextMenuLabel'>${
            menuData.label
          }</div><ul style=''>${getContextMenuListItems(menuData.options)}</ul></div>`
        );

        $controlElement.hide();

        $controlElement.appendTo('#contextMenus');

        // Highlight list items on hover
        $('#contextMenus .contextMenu').on('mouseleave', function (e) {
          $(this).hide();
        });

        applyContextMenuEvents(selector, menuData);
      }
    };
    const getContextMenuListItems = options => {
      var list = options.reduce(function (prevVal, currVal, idx) {
        if (currVal.hasOwnProperty('action')) {
          return `${prevVal}<li class='submenu'>${currVal.action}<div class='submenu'><ul>${getContextMenuListItems(
            currVal.options
          )}</ul></div></li>`;
        } else {
          let listItem = `<li class='item ${currVal[1]}${currVal[2]}${currVal[3]}'>${currVal[0]}${currVal[4]}`;
          return idx == 0 ? listItem : prevVal + listItem;
        }
      }, '');
      return list;
    };
    const applyContextMenuEvents = (parentId, menuData) => {
      menuData.options.forEach(function (option) {
        if (option.hasOwnProperty('action')) {
          applyContextMenuEvents(parentId, option);
        } else {
          let params = {
            action: option[1],
            data: {
              cid: menuData.cid,
              label: menuData.label,
              objpath: menuData.objpath,
              contentRegion: menuData.contentRegion,
              param1: option[2],
              param2: option[3],
            },
          };
          $('#' + parentId + ' li.' + option[1] + option[2] + option[3]).on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.parent) {
              window.parent.postMessage({ event_type: 'forge_mode', detail: params }, window.location.origin);
            }
            setTimeout(function () {
              $('.contextMenu, #contextMenus').hide();
            }, 75);
            e.target.display = 'none';
          });
        }
      });
    };
    //
    if (ef.forge_mode && target.hasOwnProperty('model')) {
      var icn = this.getForgeModeIcon('far', 'edit');
      var mycid = target.model.get('cid');
      var mytype = target.model.get('type');
      var mylabel = mytype;
      if (mytype === 'component' || mytype === 'layout') {
        mylabel = target.model.get('path');
      }
      var myforgepath = target.model.get('forge_path');
      const contentRegion = target.model.get('content_region') || '#page-container';
      if (myforgepath) {
        var $forgeLink = $(
          `<div class="forgeModeElement forgeLink blockDropTarget btn" data-sdkcid="${mycid}" data-forgelink="${mycid}" data-objpath="${myforgepath}" data-content-region="${contentRegion}" draggable="true">${mylabel}</div>`
        );
        $forgeLink.css('visibility', 'hidden');
        var $iconElement = $(icn);
        $iconElement.appendTo($forgeLink);
        $forgeLink.appendTo(target.$el);
        target.$el.attr('data-cid', mycid);
        target.$el.attr('data-objpath', myforgepath);
        target.$el.attr('data-content-region', contentRegion);

        //
        var params = {
          action: 'editblock',
          data: {
            cid: mycid,
            label: mylabel,
            objpath: myforgepath,
            contentRegion: contentRegion,
          },
        };
        $('*[data-forgelink="' + mycid + '"]').on('dragstart', function (ev) {
          $(`${contentRegion} .blockDropTarget`).css('visibility', 'visible');
          ev.originalEvent.dataTransfer.setData(
            'text/plain',
            `${contentRegion}|${$(ev.originalEvent.toElement).data('objpath')}`
          );
        });
        $('*[data-forgelink="' + mycid + '"]').on('dragend', function (ev) {
          $(`.blockDropTarget`).css('visibility', 'hidden');
        });
        $('*[data-forgelink="' + mycid + '"]').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.postMessage({ event_type: 'forge_mode', detail: params }, window.location.origin);
        });
        //
        var myoptions = [
          ['Edit', 'editblock', '', '', this.getForgeModeIcon('far', 'edit')],
          ['Copy', 'copyblock', '', '', this.getForgeModeIcon('far', 'copy')],
          ['Paste', 'pasteblock', '', '', this.getForgeModeIcon('far', 'paste')],
          ['Save as Pattern', 'saveaspattern', '', '', this.getForgeModeIcon('far', 'fileDownload')],
          ['Delete', 'removeblock', '', '', this.getForgeModeIcon('far', 'minusCircle')],
        ];
        this.getSubPaths(mytype, mylabel).forEach(path => {
          var children = target.model.get(path); // here we may need to handle paths of length >1
          var cloneoptions = children.map((child, idx) => {
            return [`${path}&nbsp;${idx + 1}`, 'cloneitem', path, idx, ''];
          });
          var removeoptions = children.map((child, idx) => {
            return [`${path}&nbsp;${idx + 1}`, 'removeitem', path, idx, ''];
          });
          myoptions.push({
            action: `Clone&nbsp;${path}`,
            options: cloneoptions,
            cid: mycid,
            label: mylabel,
            objpath: myforgepath,
          });
          myoptions.push({
            action: `Remove&nbsp;${path}`,
            options: removeoptions,
            cid: mycid,
            label: mylabel,
            objpath: myforgepath,
          });
        });

        createContextMenu({
          cid: mycid,
          label: mylabel,
          objpath: myforgepath,
          options: myoptions,
          contentRegion: contentRegion,
        });

        // Handle right-click events on block buttons - ***
        $('*[data-forgelink="' + mycid + '"]').on('contextmenu', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setTimeout(function () {
            $('.contextMenu').hide();
            $('#forgeContextMenu_' + mycid).show();
            $('#forgeContextMenu_' + mycid).css({
              left: '0px',
              top: '0px',
            });
            $('#contextMenus').show();
            $('#contextMenus').css({
              left: e.pageX + 'px',
              top: e.pageY + 'px',
            });
          }, 150);
        });
        //
        target.$el.hover(
          function () {
            requestAnimationFrame(() => {
              var cidref = $(this).data('cid');
              if (ef.forge_mode.active) {
                $('*[data-cid="' + cidref + '"]').css('background-color', 'rgba(0,0,255,0.05)');
                $('*[data-sdkcid="' + cidref + '"]').css('visibility', 'visible');
              } else {
                $('*[data-cid="' + cidref + '"]').css('background-color', 'unset');
                $('*[data-sdkcid="' + cidref + '"]').css('visibility', 'hidden');
              }
            });
          },
          function () {
            requestAnimationFrame(() => {
              var cidref = $(this).data('cid');
              $('*[data-cid="' + cidref + '"]').css('background-color', 'unset');
              $('*[data-sdkcid="' + cidref + '"]').css('visibility', 'hidden');
            });
          }
        );
      }
    }
  },
};

module.exports = ForgeService;
